import { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../../services/user.service';
import { useAuthStore } from '../../stores/authStore';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const getMe = useAuthStore((state) => state.getMe);
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }
    let cancelled = false;
    void verifyEmail(token)
      .then(async () => {
        await getMe();
        if (!cancelled) setStatus('success');
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });
    return () => { cancelled = true; };
  }, [token, getMe]);

  return (
    <Box sx={{ maxWidth: 520, mx: 'auto', mt: 10, p: 3 }}>
      <Stack spacing={3}>
        <Typography variant="h4">Email verification</Typography>
        {status === 'loading' && <CircularProgress />}
        {status === 'success' && <Alert severity="success">Your email is verified. You can now share boards, walls and games.</Alert>}
        {status === 'error' && <Alert severity="error">This verification link is invalid or expired. Request a new link from your profile.</Alert>}
        <Button component={Link} to="/main" variant="contained">Go to your boards</Button>
      </Stack>
    </Box>
  );
}
